import React from 'react';
import useCurrentUser from '../../../hooks/use-current-user'
import useCourses from '../../../hooks/use-courses'
import moment from 'moment'
import { find } from 'lodash'

export const ExperienceScreenContext = React.createContext({});

export const useExperienceScreenContext = () => {
    const { isFacilitator, isAdmin } = useCurrentUser()
    const [ filters, setFilters ] = React.useState({ startDate: moment().toDate() });
    const isPermitted = isAdmin || isFacilitator;
    const [ limit ] = React.useState(25)
    const [ offset, setOffset ] = React.useState(0)
    const { total, courses, isBusy } = useCourses({ filters, limit, offset, enabled: isPermitted })
    const [ selectedCourses, setSelectedCourses ] = React.useState([])

    //  Clear selection when set changes
    React.useEffect(() => {setSelectedCourses([])}, [courses])

    const toggleSelectedCourse = (course = {}) => {
        const { id } = course;
        if (find(selectedCourses, { id })) {
            setSelectedCourses(prev => prev.filter(c => c.id !== id ))
        } else {
            setSelectedCourses((prev) => [...prev, course])
        }
    }

    const isCourseSelected = React.useCallback(({ id } = {}) => Boolean(find(selectedCourses, { id })), [selectedCourses])

    //  Reset offset when filters change
    React.useEffect(() => { {setOffset(0)} }, [filters])

    const updateFilter = (key, value) => setFilters(prev => ({...prev, [key]: value }))

    return {
        isPermitted,
        filters,
        setFilters,
        updateFilter,
        setOffset,
        courses,
        isBusy,
        total,
        limit,
        toggleSelectedCourse,
        isCourseSelected,
        selectedCourses
    };
};

export const useExperienceScreen = () => React.useContext(ExperienceScreenContext);
